const en: Record<string, string> = {
  'bookmarks.empty':
    'No bookmarks yet. Browse pages and click the bookmark icon to save them here.',
  'bookmarks.add': 'Add to bookmarks',
  'bookmarks.remove': 'Remove from bookmarks',
  'bookmarks.moveUp': 'Move up',
  'bookmarks.moveDown': 'Move down',
  'bookmarks.open': 'Open page',
  'bookmarks.edit.open': 'bookmark',
  'bookmarks.edit.title': 'Edit Bookmark',
  'bookmarks.edit.name': 'Name',
  'bookmarks.edit.description': 'Description',
  'bookmarks.edit.color': 'Color',
  'bookmarks.configure': 'Configure',
  'bookmarks.configuring': 'Done',
  'bookmarks.archive': 'Archive',
};

export default en;
